import { render, staticRenderFns } from "./AppDropdown.vue?vue&type=template&id=521d1752&"
import script from "./AppDropdown.vue?vue&type=script&lang=js&"
export * from "./AppDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports